/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Send2Inputs */

const en_coinvestments_senddrafts_send2 = /** @type {(inputs: Coinvestments_Senddrafts_Send2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send now`)
};

/**
* | output |
* | --- |
* | "Send now" |
*
* @param {Coinvestments_Senddrafts_Send2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_send2 = /** @type {((inputs?: Coinvestments_Senddrafts_Send2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Send2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_send2(inputs)
});
export { coinvestments_senddrafts_send2 as "coInvestments_sendDrafts_send" }